<div class="content">

    <div class="d-flex justify-content-start mt-4">
        <ng2-smart-table [settings]="settings" [source]="listInventory" (custom)="onCustomAction($event)">
        </ng2-smart-table>
       


    </div>
    <div class="d-flex justify-content-center mt-2" *ngIf="viewLoadMoreInventory()">
        <div (click)="loadMoreInventory()"
       style="cursor: pointer;">
        <div class="d-flex align-items-center">
            <i class="fa-solid fa-arrows-rotate"></i>
            <span>Load more inventories</span>
        </div>
    </div>
        
    </div>

</div>